import React, { useState } from "react";
import "./index.css";
import toldo from "../../assets/images/png/toldo.png";
import logoHeader from "../../assets/images/svg/logoHeader.svg";

import stepIntoClawz from "../../assets/images/svg/stepIntoClawz.svg";
import licensedPlushies from "../../assets/images/svg/licensedPlushies.svg";
import meetTheZGang from "../../assets/images/svg/meetTheZGang.svg";
import locations from "../../assets/images/svg/locations.svg";
import social from "../../assets/images/svg/social.svg";
import gallery from "../../assets/images/svg/gallery.svg";
import everybodyWins from "../../assets/images/svg/everybodyWins.svg";
import news from "../../assets/images/svg/news.svg";
import joinTheRebellion from "../../assets/images/svg/joinTheRebellion.svg";
import contactUs from "../../assets/images/svg/contactUs.svg";
// import halloween from "../../assets/images/svg/halloween.svg";

import meetOurPlushies from "../../assets/images/svg/meetOurPlushies.svg";
import { slide as Menu } from "react-burger-menu";
import { useNavigate } from "react-router-dom";

const headerItems = [
  // STEP INTO CLAWZ
  {
    src: stepIntoClawz,
    alt: "Step Into Clawz - Conheça nossa história",
    title: "Conheça a história do Clawz",
    onClick: () => {
      const videoSection = document.querySelector(".video-container");
      if (videoSection) {
        videoSection.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
  // LICENSED PUSHLIES
  {
    src: licensedPlushies,
    alt: "Meet Our Plushies - Nossa coleção de pelúcias",
    title: "Conheça nossa coleção de pelúcias",
    onClick: () => {
      const cartasSection = document.querySelector(".container-kawaii");
      if (cartasSection) {
        cartasSection.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
  // MEET THE Z GANG
  {
    src: meetTheZGang,
    alt: "Meet The Z Gang - Conheça nossa equipe",
    title: "Conheça nossa equipe",
    onClick: () => {
      const cartasSection = document.querySelector(".cartas-container");
      if (cartasSection) {
        cartasSection.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
  // LOCATIONS
  {
    src: locations,
    alt: "Locations - Encontre uma loja Clawz próxima a você",
    title: "Localize uma loja Clawz",
    onClick: () => {
      const cardGpsSection = document.querySelector(".card-gps-container");
      if (cardGpsSection) {
        cardGpsSection.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
  // SOCIAL
  {
    src: social,
    alt: "Social - Redes sociais da Clawz",
    title: "Redes sociais",
    onClick: () => {
      window.open(
        "https://linktr.ee/clawz.us?fbclid=PAZXh0bgNhZW0CMTEAAafWRBeph1SP-W-f8HlcPs1CbIgsk89c4cxvPKwDf6UliR89dhiXrDjO0x7Wrg_aem_vanZHtXunJtxahHAHSiagQ",
        "_blank"
      );
    },
  },
  // GALLERY
  {
    src: gallery,
    alt: "Gallery - Galeria de fotos da Clawz",
    title: "Galeria de fotos",
    onClick: () => {
      const galeriaSection = document.querySelector(".coming-soon-image");
      if (galeriaSection) {
        galeriaSection.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
  // EVERYBODY WINS
  {
    src: everybodyWins,
    alt: "Everybody Wins - Promoções e prêmios Clawz",
    title: "Promoções e prêmios",
    onClick: () => {
      const element1 = document.querySelector(".scrollClawrranty1");
      if (element1) {
        element1.scrollIntoView({ behavior: "smooth" });
      }
      const element2 = document.querySelector(".scrollClawrranty2");
      if (element2) {
        element2.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
  // NEWS
  {
    src: news,
    alt: "News - Últimas notícias e novidades da Clawz",
    title: "Notícias e novidades",
    onClick: () => {
      const galeriaSection = document.querySelector(".titulo-galeria-news");
      if (galeriaSection) {
        galeriaSection.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
  // JOIN THE REBELLION
  {
    src: joinTheRebellion,
    alt: "Join The Rebellion - Faça parte da nossa comunidade",
    title: "Junte-se à nossa comunidade",
    onClick: () => {
      const joinSection = document.querySelector(".join-container");
      if (joinSection) {
        joinSection.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
  // CONTACT US
  {
    src: contactUs,
    alt: "Contact Us - Entre em contato com a Clawz",
    title: "Fale conosco",
    onClick: () => {
      window.open("mailto:clawz@clawz.us");
    },
  },
  // HALLOWEEN
  // {
  //   src: halloween,
  //   alt: "Halloween - Halloween na Clawz",
  //   title: "Halloween na Clawz",
  //   onClick: () => {
  //      window.open("/halloween");
  //   },
  // },
];

export default function Header() {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleStateChange = (state) => {
    setIsMenuOpen(state.isOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleItemClick = (onClick) => {
    closeMenu();
    if (onClick) onClick();
  };

  return (
    <header className="header" role="banner">
      <nav role="navigation" aria-label="Menu principal">
        <Menu isOpen={isMenuOpen} onStateChange={handleStateChange}>
          {headerItems.map((item, index) => (
            <div
              className="d-flex justify-content-center"
              style={{ margin: "-20px 10px" }}
              key={index}
            >
              <button
                className="btn ticker-item"
                onClick={() => handleItemClick(item.onClick)}
                aria-label={item.alt}
                title={item.title}
              >
                <img src={item.src} alt={item.alt} height={50} loading="lazy" />
              </button>
            </div>
          ))}
        </Menu>
      </nav>

      <div className="d-flex justify-content-center pt-3 pe-md-0 p-4">
        <img
          src={logoHeader}
          alt="Logo Clawz - Máquinas de Pelúcias"
          width="160"
          height="80"
          loading="eager"
        />
      </div>

      <div
        className="ticker-container"
        role="marquee"
        aria-label="Menu de navegação em movimento"
      >
        <div className="ticker-content">
          {Array(30)
            .fill(headerItems)
            .flat()
            .map((item, index) => (
              <img
                key={index}
                className="ticker-item"
                src={item.src}
                alt={item.alt}
                width="150"
                height="50"
                loading="lazy"
                onClick={() => handleItemClick(item.onClick)}
              />
            ))}
        </div>
      </div>
    </header>
  );
}
